<template>
  <form
    id="pillar-group-form"
    ref="pillar-group-form"
    class="tw-max-w-full tw-mx-auto tw-flex-shrink-0 tw-mb-20 auth-card tw-flex tw-flex-wrap"
    method="post"
    action="/survey-question/create"
    @submit.prevent="onSubmit"
  >

    <div class="tw-w-full tw-mb-4">
      <h1 class="tw-text-4xl font-title">{{ questionId ? 'Edit Survey Question' : 'Add a Survey Question' }}</h1>
      <!-- <h6 class="tw-text-base opacity-78 tw-text-app-deep-blue">Please fill all inputs</h6> -->
    </div>

    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <SelectGroup
        label="Survey Type"
        name="surveyTypeId"
        nameKey="name"
        placeholder="Survey Type"
        input-classes="my-select--huge tw-font-sans tw-bg-gray-200 tw-text-left"
        v-model="form.surveyTypeId"
        :options="surveyTypes"
        :reduce="type => type.id"
        :selected="form.surveyTypeId"
        :clearable="false"
        :error="errors.surveyTypeId"
      />
    </div>

    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        :class="{ '--loading-data': loadingForm }"
        label="Survey Question"
        name="survey-question"
        type="text"
        placeholder="Survey question"
        input-classes="tw-p-3"
        v-model="form.question"
        :error="errors.question"
      />
    </div>

    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <SelectGroup
        label="Question Type"
        name="questionTypeId"
        nameKey="q_type"
        placeholder="Question Type"
        input-classes="my-select--huge tw-font-sans tw-bg-gray-200 tw-text-left"
        v-model="form.questionTypeId"
        :options="questionTypes"
        :reduce="type => type.id"
        :selected="form.questionTypeId"
        :clearable="false"
        :error="errors.questionTypeId"
      />
    </div>

    <div class="tw-w-full tw-flex-shrink-0 tw-px-1 tw-mb-4 tw-pt-10">
      <BaseButton
        type="submit"
        :class="[
          'tw-block tw-w-full md:tw-inline-block md:tw-w-auto tw-mb-4 tw-py-3 tw-px-8',
          `${btnClass}`
        ]"
        :text="btnText"
        :disabled="!canSubmit || btnDisabled"
      />
    </div>

  </form>
</template>

<script>
import _debounce from 'lodash/debounce';

// import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';
import InputGroup from '@/components/InputGroup.vue';
import SelectGroup from '@/components/SelectGroup.vue';

import form from '@/modules/formHelper';

export default {
  name: 'EditSurveyQuestion',
  components: {
    // QuillTextareaGroup,
    InputGroup,
    SelectGroup,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    companyProgram: {
      type: Object,
      required: true,
    },
    questionId: {
      type: [String, Number],
      default: undefined,
    },
    // surveyId: {
    //   type: [String, Number],
    //   required: true,
    // },
    btnClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingForm: true,
      errorForm: undefined,
      btnText: 'Save',
      btnDisabled: false,
      questionTypes: [],
      surveyTypes: [],
      form: {
        question: '',
        questionTypeId: undefined,
        surveyTypeId: undefined,
      },
      errors: {},
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'company.id': function () {
      this.resetForm();
      this.loadForm();
    },
    // eslint-disable-next-line func-names
    'companyProgram.id': function () {
      this.resetForm();
      this.loadForm();
      this.getProgramSurveyQuestionTypes();
      this.getProgramSurveyTypes();
    },
    // surveyId() {
    //   this.resetForm();
    //   this.loadForm();
    // },
    questionId() {
      this.resetForm();
      this.loadForm();
    },
  },
  computed: {
    canSubmit() {
      return form.isValidTextInput(this.form.question)
        && !this.loadingForm
        && this.company.id !== undefined
        && this.companyProgram.id !== undefined
        && this.form.questionTypeId !== undefined
        && this.form.surveyTypeId !== undefined;
    },
  },
  methods: {
    async getProgramSurveyQuestionTypes() {
      const surveyQuestionTypes = await this.$store.dispatch('getProgramSurveyQuestionTypes', [this.companyProgram.id, true]);

      if (!surveyQuestionTypes) {
        this.error = 'Could not get surveys question types. Please try again later';

        return;
      }

      this.questionTypes = surveyQuestionTypes;
    },

    async getProgramSurveyTypes() {
      const surveyTypes = await this.$store.dispatch('getProgramSurveyTypes', [this.companyProgram.id, true]);

      if (!surveyTypes) {
        this.error = 'Could not get surveys types. Please try again later';

        return;
      }

      this.surveyTypes = surveyTypes;
    },

    resetForm() {
      this.form = {
        question: '',
      };
    },
    // eslint-disable-next-line func-names
    loadForm: _debounce(async function () {
      this.loadingForm = true;
      this.errorForm = undefined;

      // * get question details if questionId is defined
      if (this.questionId) {
        const surveyQuestions = await this.$store.dispatch('getProgramSurveyQuestions', [this.companyProgram.id, true, false]);

        if (!surveyQuestions) {
          this.$toasted.global.appError({
            errorMessage: 'Could not get survey question. Please try again later',
          });

          return;
        }

        const curr = surveyQuestions.find((r) => Number(r.id) === Number(this.questionId)) || {};

        this.form.question = curr.question;
        this.form.surveyTypeId = curr.surveyType.id;
        this.form.questionTypeId = curr.type.id;
      }

      await this.$nextTick();
      await this.$nextTick();

      this.loadingForm = false;
    }, 300),
    async onSubmit() {
      if (!this.canSubmit) {
        this.$toasted.global.appError({
          errorMessage: 'You can\'t submit the form. Check for empty inputs',
        });

        console.warn('Cannot submit form... \n check for empty inputs');
        return false;
      }

      // signup!!
      this.btnDisabled = true;
      this.btnText = 'working...';

      const data = {
        ...(this.form),
        companyId: this.company.id,
        programId: this.companyProgram.id,
        // surveyId: this.surveyId,
        id: this.questionId,
      };

      const result = await this.$store.dispatch('saveProgramSurveyQuestion', data);

      if (result) {
        this.$toasted.success('Saved!', { duration: 1000 });
        this.$emit('created-success');

        if (this.questionId) {
          this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.editSurveyQuestion);
        } else {
          this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.addSurveyQuestion);
        }
      } else {
        this.$toasted.global.appError({
          errorMessage: 'Saving survey question failed. Please try again later',
        });
      }

      this.btnDisabled = false;
      this.btnText = 'save';

      return true;
    },
  },
  async created() {
    this.errors = { ...this.form };

    await this.$nextTick();
    await Promise.all([
      this.loadForm(),
      this.getProgramSurveyQuestionTypes(),
      this.getProgramSurveyTypes(),
    ]);

    await this.$nextTick();

    this.loadingForm = false;
  },
};
</script>

<style>

</style>
